
export default {
    namespaced: true,
    state: {
        chooseFromPage: '',
        chooseRecordType: 'single', //单个:single，多个:multiple
        chooseRecordGender: 0, //0全部, 1男, 2女
        curTabIndex: 0,
        lastChoosedSingleItem: null,
        curChoosedSingleItem: null,
        choosedMultipleItemList: [],
        defaultSelectedListLength: 0,
        chooseSearchResultList: []
    },
    mutations: {},
    actions: {
        chooseSingleRecordItem({ dispatch, state }, data) {
            if(state.curChoosedSingleItem == null && state.lastChoosedSingleItem == null) {
                state.curChoosedSingleItem = Object.assign({}, data);
            }else if(state.curChoosedSingleItem != null) {
                state.lastChoosedSingleItem = Object.assign({}, state.curChoosedSingleItem);
                state.curChoosedSingleItem = Object.assign({}, data);
                if(state.lastChoosedSingleItem.id == state.curChoosedSingleItem.id) { return; }
                dispatch('record/updateRecordListChoosedItemStatus', {
                    curData: state.curChoosedSingleItem,
                    lastData: state.lastChoosedSingleItem
                }, {root: true});
                dispatch('search/updateSearchListChoosedItemStatus', {
                    curData: state.curChoosedSingleItem,
                    lastData: state.lastChoosedSingleItem
                }, {root: true});
            }
        },
        chooseMultipleRecordItem({ state }, data) {
            console.log('chooseMultipleRecordItem-----', data);
            if(data.selected) {
                state.choosedMultipleItemList.push(data);
            }else {
                let choosedList = [].concat(state.choosedMultipleItemList);
                state.choosedMultipleItemList = choosedList.filter(el => el.id != data.id)
            }
        },
        initChoosedMultipleItemList({ dispatch, state }, params) {
            state.defaultSelectedListLength = params.bzArr.length;
            dispatch('record/initRecordListChoosedItemStatus', params, {root: true});
        },
        getChoosedSearchResultList({ state }, text) {
            let recordTotalData = AppFate.$store.state.record.recordTotalData;
            let tempList = recordTotalData.filter(data => data.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
                state.chooseSearchResultList = [].concat(tempList);
            console.log("getChoosedSearchResultList-----", text, state.chooseSearchResultList);
        },
        resetData({ dispatch, state }) {
            state.curTabIndex = 0;
            state.choosedMultipleItemList = [];
            state.defaultSelectedListLength = 0;
            state.chooseSearchResultList = [];
            state.lastChoosedSingleItem = null;
            state.curChoosedSingleItem = null;
            // 重置选择数据
            dispatch('record/resetRecordListChoosedItemStatus', {}, {root: true});
            dispatch('search/resetSearchListChoosedItemStatus', {}, {root: true});
        }
    }
}